import React, { useEffect, useState } from "react";
import { dummyAnnexuresList1 } from "../../DummyAnnexureConstants";
import { Autocomplete, Chip, TextField } from "@mui/material";
import "./annexureFormRender.scss";
import { useImmer } from "use-immer";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  MobileDateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import axios from "axios";
import axiosInstancePcdo from "../../../../pcdoAxiosInstance";
import { APP_BASE_URL_PCDO } from "../../../../../../Common/EndPoints";

const TextfieldComponent = ({ field, formData, onChange, label }) => {
  const { key, type } = field;
  const { validator } = type;
  const [errorState, setErrorState] = useImmer({
    errorStatus: false,
    errorText: "",
  });
  let editable = true;
  if (type?.editable && type?.editable === false) {
    editable = false;
  }
  const handleTextfieldChange = (e) => {
    let inputValue = e.target.value;
    if (validator?.is_numeric || validator?.is_integer) {
      if (validator?.is_integer) {
        inputValue = inputValue.replace(/\D/g, "");
      }
      if (validator?.is_numeric) {
        inputValue = inputValue
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*)\./g, "$1");
      }
      const numVal = Number(inputValue);
      if (validator?.min && numVal < validator?.min) {
        setErrorState((prev) => {
          prev.errorStatus = true;
          prev.errorText = `min: ${validator?.min}`;
        });
      } else if (validator?.max && numVal > validator?.max) {
        setErrorState((prev) => {
          prev.errorStatus = true;
          prev.errorText = `max: ${validator?.max}`;
        });
      } else {
        if (validator?.is_required && inputValue?.length === 0) {
          setErrorState((prev) => {
            prev.errorStatus = true;
            prev.errorText = `it is required field`;
          });
        } else {
          setErrorState((prev) => {
            prev.errorStatus = false;
            prev.errorText = ``;
          });
        }
      }
    } else {
      if (validator?.min_len && inputValue.length < validator?.min_len) {
        setErrorState((prev) => {
          prev.errorStatus = true;
          prev.errorText = `min_len: ${validator?.min_len}`;
        });
      } else if (validator?.max_len && inputValue.length > validator?.max_len) {
        setErrorState((prev) => {
          prev.errorStatus = true;
          prev.errorText = `max_len: ${validator?.max_len}`;
        });
      } else {
        if (validator?.is_required && inputValue?.length === 0) {
          setErrorState((prev) => {
            prev.errorStatus = true;
            prev.errorText = `it is required field`;
          });
        } else {
          setErrorState((prev) => {
            prev.errorStatus = false;
            prev.errorText = ``;
          });
        }
      }
    }

    onChange(field, inputValue);
  };
  return (
    <div className="form-input-container" key={key}>
      <TextField
        size="small"
        disabled={!editable}
        required={validator?.is_required ?? false}
        value={formData?.[key] ?? ""}
        onChange={(e) => {
          handleTextfieldChange(e);
        }}
        label={label}
        className="input-field"
      />
      <div className="error-text">{errorState.errorText}</div>
    </div>
  );
};

const DropdownComponent = ({ field, formData, onChange, label }) => {
  const { key, type } = field;
  const { validator } = type;
  const [errorState, setErrorState] = useImmer({
    errorStatus: false,
    errorText: "",
  });
  let editable = true;
  if (type?.editable && type?.editable === false) {
    editable = false;
  }
  const value = (formData?.[key] ?? []).map((val) => {
    return { id: val, label: val };
  });
  const options = type?.options
    ? type?.options?.map((opt) => {
      return { id: opt, label: opt };
    })
    : [];
  const handleDropdownChange = (value) => {
    let valArray = value ? [...value] : [];
    valArray = valArray.map((val) => val.id);
    if (!validator?.multiple && valArray.length > 1) {
      valArray = [valArray[valArray.length - 1]];
    }
    onChange(field, valArray);
  };

  return (
    <div className="form-input-container">
      <Autocomplete
        multiple
        size="small"
        options={options}
        value={value}
        disabled={!editable}
        required={validator?.is_required ?? false}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(opt, val) => opt.id === val.id}
        onChange={(event, value) => {
          handleDropdownChange(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            required={validator?.is_required ?? true}
            size="small"
            disabled={!editable}
            label={label}
          />
        )}
      />
      <div className="error-text">{errorState.errorText}</div>
    </div>
  );
};

const DatePickerComponent = ({ field, formData, onChange, label }) => {
  const { key, type } = field;
  const { validator } = type;
  let editable = true;
  if (type?.editable && type?.editable === false) {
    editable = false;
  }
  const [errorState, setErrorState] = useImmer({
    errorStatus: false,
    errorText: "",
  });
  let dateValue = formData?.[key] ?? null;
  if (dateValue) {
    dateValue = dayjs(Number(dateValue));
  }

  const handleDatePickerChange = (value) => {
    const ts = value?.valueOf();
    if (ts) {
      onChange(field, ts);
    }
  };
  return (
    <div className="form-input-container">
      <LocalizationProvider size="small" dateAdapter={AdapterDayjs}>
        {type.field === "datepicker" && (
          <DatePicker
            label={label}
            size="small"
            disabled={!editable}
            value={dateValue}
            onChange={(value) => {
              handleDatePickerChange(value);
            }}
            renderInput={(params) => (
              <TextField size="small" {...params} disabled={!editable} />
            )}
          />
        )}
        {type.field === "datetimepicker" && (
          <MobileDateTimePicker
            label={label}
            size="small"
            disabled={!editable}
            value={dateValue}
            onChange={(value) => {
              handleDatePickerChange(value);
            }}
            renderInput={(params) => (
              <TextField size="small" {...params} disabled={!editable} />
            )}
          />
        )}
      </LocalizationProvider>
      <div className="error-text">{errorState.errorText}</div>
    </div>
  );
};
const AttachmentComponent = ({ field, formData, onChange, label }) => {
  const { key, type } = field;
  const { validator } = type;
  const [errorState, setErrorState] = useImmer({
    errorStatus: false,
    errorText: "",
  });
  let editable = true;
  if (type?.editable && type?.editable === false) {
    editable = false;
  }
  const [attachmentList, setAttachmentList] = useState(formData?.[key] ?? []);
  const [isLoading, setIsLoading] = useState();
  useEffect(() => {
    onChange(field, attachmentList);
  }, [attachmentList]);

  const handleAttachmentChange = async (files) => {
    setIsLoading(true);
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      const url = "/annexure/instance/row/attachment";
      const uploadAttachRes = await axiosInstancePcdo.post(url, formData);
      const uploadedPaths = uploadAttachRes?.data ?? [];
      setIsLoading(false);
      setAttachmentList((prev) => [...prev, ...uploadedPaths]);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleDeleteChip = (list, index) => {
    const _list = [...list];
    _list.splice(index, 1);
    setAttachmentList(_list);
  };
  const handleClick = (filePath) => {
    const url = `${APP_BASE_URL_PCDO}/annexure/instance/row/attachment/${filePath}`;
    window.open(url);
  };
  return (
    <div className="form-input-container">
      <h4>{label ?? ""}</h4>
      <div className="attachment-field-container">
        <div className="selected-attachment">
          {attachmentList.map((file, i) => {
            const fileName = file.substring(37);

            return (
              <Chip
                key={i}
                disabled={isLoading || !editable}
                size="small"
                label={fileName}
                variant="outlined"
                onClick={() => handleClick(file)}
                onDelete={() => {
                  handleDeleteChip(attachmentList, i);
                }}
              />
            );
          })}
          {!attachmentList?.length && (
            <div className="no-file-text">No file uploaded yet</div>
          )}
        </div>

        <input
          type="file"
          disabled={isLoading || !editable}
          id="files"
          accept={
            validator?.formats || validator?.formats?.length
              ? validator.formats.toString()
              : ""
          }
          className="attachment-input"
          onChange={(e) => handleAttachmentChange(e.target.files)}
          name="files"
          multiple
        ></input>
      </div>

      <div className="error-text">{errorState.errorText}</div>
    </div>
  );
};

function DynamicForm({ formData, fields, handleFieldChange }) {
  const renderField = (field, handleFieldChange) => {
    const { key, type, childs } = field;
    let label = type.label ?? "";
    if (type.prefix) {
      label = `${type.prefix} ${label}`;
    }
    if (type.suffix) {
      label = `${label} (${type.suffix})`;
    }

    switch (type.field) {
      case "textbox":
        return (
          <TextfieldComponent
            field={field}
            label={label}
            formData={formData}
            onChange={handleFieldChange}
          />
        );
      case "dropdown":
        return (
          <DropdownComponent
            field={field}
            label={label}
            formData={formData}
            onChange={handleFieldChange}
          />
        );
      case "datepicker":
      case "datetimepicker":
        return (
          <DatePickerComponent
            field={field}
            label={label}
            formData={formData}
            onChange={handleFieldChange}
          />
        );
      case "attachment":
        return (
          <AttachmentComponent
            field={field}
            label={label}
            formData={formData}
            onChange={handleFieldChange}
          />
        );
      case "void":
        return (
          <div className="form-section">
            <h4 className="form-section-heading">{type.label}</h4>
            {childs &&
              childs.map((child) => renderField(child, handleFieldChange))}
          </div>
        );
      default:
        return null;
    }
  };

  return <>{fields.map((field) => renderField(field, handleFieldChange))}</>;
}

function AnnexureFormRender({ formData, handleFormDataChange, formJson }) {
  const handleFieldChange = (fieldInfo, fieldValue) => {
    handleFormDataChange(fieldInfo, fieldValue);
  };
  return (
    <div className="annexure-form-render-container">
      <DynamicForm
        formData={formData}
        fields={formJson}
        handleFieldChange={handleFieldChange}
      />
    </div>
  );
}

export default AnnexureFormRender;
